import PopIn from '@components/layout/PopIn'
import { GREY_COLORS } from '@config/theme/colors'
import { Typography } from '@mui/material'
import { usePersonApi } from '@services/api/person.api'
import { useSnackbar } from '@services/contexts/SnackbarContext'
import { useMutation } from '@tanstack/react-query'
import { FormattedMessage, useIntl } from 'react-intl'

type TraineeDeletionPopInProps = {
	id: string
	isOpen: boolean
	onClose: () => void
	onSuccess: () => void
}

const TraineeDeletionPopIn = (
	{
		id,
		isOpen,
		onClose,
		onSuccess
	}: TraineeDeletionPopInProps
) => {
	const { formatMessage } = useIntl()
	const { deleteTrainee } = usePersonApi()
	const { addErrorSnackbar, addSnackbar } = useSnackbar()

	const { mutate: deleteTraineeMutate } = useMutation({
		mutationKey: ['deleteTrainee', id],
		mutationFn: () => deleteTrainee(id),
		onSuccess: () => {
			onSuccess()
			addSnackbar(formatMessage({ id: 'trainee.information.buttons.delete.success' }))
		},
		onError: () => addErrorSnackbar()
	})

	return (
		<PopIn
			buttons={[
				{
					label: formatMessage({ id: 'global.buttons.delete' }),
					onClick: deleteTraineeMutate
				},
				{
					label: formatMessage({ id: 'global.buttons.cancel' }),
					onClick: onClose,
					variant: 'tertiary'
				}
			]}
			isOpen={isOpen}
			onClose={onClose}
			title={formatMessage({ id: 'trainee.information.buttons.delete.title' })}
		>
			<Typography color={GREY_COLORS[500]}>
				<FormattedMessage id="trainee.information.buttons.delete.message" />
			</Typography>
		</PopIn>
	)
}

export default TraineeDeletionPopIn
